export default "__VITE_ASSET__ef284485__"